import fetch, { scheduleTokenRefresh } from 'auth/FetchInterceptor'

const AuthService = {}

AuthService.login = async function (data) {
	const response = await fetch({
		url: '/auth/login',
		method: 'post',
		data: data
	});
	
	// Schedule proactive token refresh after successful login
	if (response.token) {
		scheduleTokenRefresh(response.token);
	}
	
	return response;
}

AuthService.register = function (data) {
	return fetch({
		url: '/auth/register',
		method: 'post',
		data: data
	})
}

AuthService.logout = function (data) {
	return fetch({
		url: '/auth/logout',
		method: 'post',
		data: data
	})
}

AuthService.refreshToken = function (data) {
	return fetch({
		url: '/auth/refresh-token',
		method: 'post',
		data: data
	})
}

AuthService.me = function () {
	return fetch({
		url: '/auth/me',
		method: 'get'
	})
}

AuthService.changePassword = function (data) {
	return fetch({
		url: '/auth/change-password',
		method: 'post',
		data: data
	})
}

AuthService.getSessions = function () {
	return fetch({
		url: '/auth/sessions',
		method: 'get'
	})
}

AuthService.revokeSession = function (sessionId) {
	return fetch({
		url: `/auth/sessions/${sessionId}`,
		method: 'delete'
	})
}

export default AuthService;
